/**
 * Requerimiento info card for AtencionDialog
 */
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Badge } from '../ui/badge';
import { Building } from 'lucide-react';

const AtencionRequerimientoInfo = ({ requerimiento }) => {
  if (!requerimiento) return null;

  return (
    <Card className="border-[#E8E8E7]">
      <CardHeader className="pb-3">
        <CardTitle className="text-base sm:text-lg flex items-center gap-2">
          <Building size={18} className="text-[#9d8272]" />
          Información del Requerimiento
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 text-sm">
          <div className="bg-[#FAFAFA] p-2 rounded">
            <span className="text-xs text-[#888888]">Código</span>
            <p className="font-semibold text-[#9d8272]">#{requerimiento.codigo}</p>
          </div>
          <div className="bg-[#FAFAFA] p-2 rounded">
            <span className="text-xs text-[#888888]">Proyecto</span>
            <p className="font-medium truncate">{requerimiento.proyecto_nombre || 'N/A'}</p>
          </div>
          <div className="bg-[#FAFAFA] p-2 rounded">
            <span className="text-xs text-[#888888]">Etapa</span>
            <p className="font-medium">{requerimiento.etapa || 'N/A'}</p>
          </div>
          <div className="bg-[#FAFAFA] p-2 rounded">
            <span className="text-xs text-[#888888]">Departamento</span>
            <p className="font-medium">{requerimiento.departamento || 'N/A'}</p>
          </div>
          <div className="bg-[#FAFAFA] p-2 rounded col-span-2">
            <span className="text-xs text-[#888888]">Cliente</span>
            <p className="font-medium">{requerimiento.cliente_nombre || 'N/A'}</p>
          </div>
          <div className="bg-[#FAFAFA] p-2 rounded col-span-2">
            <span className="text-xs text-[#888888]">Estado</span>
            <Badge className="bg-blue-100 text-blue-700">
              {requerimiento.estado?.replace('_', ' ')}
            </Badge>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default AtencionRequerimientoInfo;
